//jQuery exists extension method
//To use, call .exists() on any jQuery object or selector to see if it exists on the page
//Sample Code: if ( $('.yourClass').exists() ) { //your code here }
$.fn.exists = function () {
    return this.length !== 0;
}